export default __webpack_public_path__ + "cf956d7e03a110313ca2cd29e4e93746.png";